import React from "react";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import { generateKey } from "../../utils/utils";
import { useBundle } from "@amzn/react-arb-tools";
import { POLICYPAGE_MESSAGE_BUNDLE_NAME } from "src/constants";
import { t } from "src/helpers";

const BulletPoints = ({ heading, paragraph }) => {
  const [bundle] = useBundle(POLICYPAGE_MESSAGE_BUNDLE_NAME);

  return (
    <Column spacing={"100"}>
      <Text type="b200">{heading}</Text>
      <Text type="b200" tag="ul">
        {paragraph.map((el, index) => (
          <li key={generateKey(index)}>{t(bundle, el)}</li>
        ))}
      </Text>
    </Column>
  );
};

export default BulletPoints;
